import React, { Fragment } from "react";

import { useTealium } from "@hubcapp/context";

import SupportButton from "./SupportButton";

const SupportButtonStateProvider = () => {
  const { trackEvent } = useTealium();

  const openHug = () => {
    trackEvent({
      eventCategory: "Menu",
      eventAction: "Interaction",
      eventLabel: "View Support Page",
    });
    window.open("https://help.drivingservices.org/", "hubcappHelp");
  };

  return (
    <Fragment>
      <SupportButton
        title="Need help?"
        subtitle="View support pages"
        onClick={openHug}
      />
    </Fragment>
  );
};

export default React.memo(SupportButtonStateProvider);
